import { Fragment } from 'react/jsx-runtime';
import { Patient } from '../../store/types/patient';
import { getAgeString } from '../../store/utils';

export const GenderAndAgeComponent: React.FC<{ pt: Patient }> = ({ pt }) => {
    return (
        <Fragment>
            {pt.personal.gender && pt.personal.gender[0] && (
                <span>
                    {`${pt.personal.gender[0].toUpperCase()}${pt.personal.gender.slice(1)}`}
                </span>
            )}{' '}
            |{' '}
            {pt.personal.age && (
                <span>
                    {`${getAgeString({
                        age: pt.personal.age.value,
                        month: pt.personal.age.month,
                        dob: pt.personal.age.dob,
                    })}`}
                </span>
            )}
        </Fragment>
    );
};
